export default function ModalUploadFile(props) {
    return (
        <div
            className="modal"
            style={{ display: "none" }}
            tabIndex={-1}
            id="web_modal_upload"
        >
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">Upload Image/File</h5>
                <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                >
                <span aria-hidden="true">×</span>
                </button>
            </div>
            <form action="#" method="POST" id="web_modal_form_upload">
                <div className="modal-body">
                <input
                    type="file"
                    name="file"
                    required=""
                    accept="image/*"
                    capture="environment"
                />
                <input type="hidden" name="lat" value="" className="val_pos_lat" />
                <input type="hidden" name="lng" value="" className="val_pos_lng" />

                <div
                    className="web_upload_progress"
                    style={{ display: "none", marginTop: 20 }}
                >
                    <p>
                    Uploading (<span className="progress_val">0</span>%)...
                    </p>
                    <div className="progress">
                    <div
                        className="progress-bar progress-bar-striped"
                        role="progressbar"
                        style={{ width: "20%" }}
                    />
                    </div>
                </div>
                <div
                    className="web_upload_errorbox text-danger"
                    style={{ marginTop: 10, display: "none" }}
                />
                </div>
                <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                >
                    Close
                </button>
                </div>
            </form>
            </div>
        </div>
        </div>

    );
};
